import React, { Component } from "react";
import Page from 'react-page-loading'

import Header from "../common/Header";
import Sidebar from "./Sidebar";
import { Link } from "react-router-dom";

import NumberFormat from "react-number-format";

import { Line, Bar, Chart, Doughnut } from 'react-chartjs-2';


import axios from "axios";
import swal from 'sweetalert';

export class AdminDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: localStorage["appState"]
              ? JSON.parse(localStorage["appState"]).user.token
              : "",
            user: [],
            homes_total: "",
            users_total: "",
            lands_total: "",
            homes_sub_total: "",
            lands_sub_total: "",
            homes_sum_total: "",
            lands_sum_total: "",
    };
  }
  componentDidMount() {
    axios
            .get(`${axios.defaults.baseURL}/user/${JSON.parse(localStorage["appState"]).user.id}`,
            {
              headers: {
                'Authorization': `Bearer ${this.state.token}`
              }
            }
            )
            .then(response => {
              //console.log(response);
              return response;
            })
            .then(json => {
              if (json.data.success) {
                this.setState({ user: json.data.user[0] });
              // } else alert("Cannot Fetch Data!");
              } else swal("Oops!", "Cannot Fetch Data!", "error");;
            })
            .catch(error => {
              console.error(`An Error Occured! ${error}`);
            });
            // alert(id)
    this.getChartData();
  }

  getChartData(){
    axios
      .get(
        `${axios.defaults.baseURL}/chart/${
          JSON.parse(localStorage["appState"]).user.id
        }`,
        {
          headers: {
            Authorization: `Bearer ${this.state.token}`,
          },
        }
      )
      .then((response) => {
        // console.log(response);
        return response;
      })
      .then((json) => {
        if (json.data.success) {
          this.setState({
            users_total: json.data.users_total,
            homes_total: json.data.homes_total,
            lands_total: json.data.lands_total,
            homes_sub_total: json.data.homes_sub_total,
            lands_sub_total: json.data.lands_sub_total,
            homes_sum_total: json.data.homes_sum_total,
            lands_sum_total: json.data.lands_sum_total,
          });
          // } else alert("Cannot Fetch Data!");
        } else swal("Oops!", "Cannot Fetch Data!", "error");
      })
      .catch((error) => {
        console.error(`An Error Occured! ${error}`);
      });
  }
  
  logoutUser = () => {
    localStorage.clear();
    window.location.href = '/auth';
  };
  render() {
    const doudata = {
      labels: [
        'Red',
        'Green',
        'Yellow'
      ],
      datasets: [{
        data: [300, 50, 100],
        backgroundColor: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56'
        ],
        hoverBackgroundColor: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56'
        ]
      }]
    };
    const linedata = {
        labels: ['Evest', 'Landvest'],
        datasets: [
          {
            label: 'Plans Chart',
            fill: false,
            lineTension: 0.1,
            backgroundColor: 'rgba(75,192,192,0.4)',
            borderColor: 'rgba(75,192,192,1)',
            borderCapStyle: 'butt',
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: 'miter',
            pointBorderColor: 'rgba(75,192,192,1)',
            pointBackgroundColor: '#fff',
            pointBorderWidth: 1,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'rgba(75,192,192,1)',
            pointHoverBorderColor: 'rgba(220,220,220,1)',
            pointHoverBorderWidth: 2,
            pointRadius: 1,
            pointHitRadius: 10,
            data: [ this.state.homes_total , this.state.lands_total, 0]
          }
        ]
      };
    return (
    <>
    <Page loader={"spin"} color={"#449400"} duration={1} size={10}>
      <div id="app" className="bg-gray-200">
        <div className="dashboard-page">
          <div className="private-layout">
            <div className="app-wrapper">
              <Sidebar />
              <Header />
              <div id="main-app" className="position-relative">
                <div className="container mt-4">
                  <div className="row align-items-stretch">
                    <div className="mb-4 portfolio-card col-lg-12 col-12">
                      <div className="wrapper h-100 p-4 dash-card admin shadow-xl col">
                        <div className="row">
                          <div className="col-12">
                            <small className="mb-2 h6 text-dark font-weight-bolder">
                              Welcome Admin,
                            </small>
                            <small
                              className="ml-1"
                              style={{ marginTop: "-10px" }}
                            ></small>
                            <Bar data={linedata} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                  <div class="mb-2 col-md-6 col-12">
                            <Link
                              to=""
                              class="btn dash-card p-4 shadow-xl outline evest action-btn w-100"
                              target="_self"
                            >
                              
                              <h3
                                  style={{
                                    marginTop: "50px",
                                    fontStyle: "italic",
                                    textTransform: "capitalize"
                                  }}
                                  className="text-dark"
                                >
                                  Subscribers: {this.state.homes_sub_total || 0}
                                </h3>
                                <h3
                                  style={{
                                    marginTop: "50px",
                                    fontStyle: "italic",
                                    textTransform: "capitalize"
                                  }}
                                  className="text-dark"
                                >
                                  Payments: <NumberFormat
                                        value={this.state.homes_sum_total  || 0}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"₦"}
                                      />
                                </h3>
                            </Link>
                          </div>
                          <div class="mb-2 col-md-6 col-12">
                            <Link
                              to=""
                              class="btn dash-card p-4 shadow-xl outline lvest action-btn w-100"
                              target="_self"
                            >
                              
                              <h3
                                  style={{
                                    marginTop: "50px",
                                    fontStyle: "italic",
                                    textTransform: "capitalize"
                                  }}
                                  className="text-dark"
                                >
                                  Subscribers: {this.state.lands_sub_total  || 0}
                                </h3>
                                <h3
                                  style={{
                                    marginTop: "50px",
                                    fontStyle: "italic",
                                    textTransform: "capitalize"
                                  }}
                                  className="text-dark"
                                >
                                  Payments: <NumberFormat
                                        value={this.state.lands_sum_total || 0}
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        prefix={"₦"}
                                      />
                                </h3>
                            </Link>
                          </div>
                  </div>
                </div>
              <br/>
              <br/>
              <br/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
    </>
    );
  }
}

export default AdminDashboard;
